import { Language } from "@shared/locales";

export const aanvraagDocumentS1GezinsledenNamespace = "aanvraag-document-s1-gezinsleden";

export const aanvraagDocumentS1GezinsledenUrlPaths: Record<Language, string> = {
  [Language.Nederlands]: "zelf-regelen/aanvraag-cak-verzekering-gezinsleden-in-het-buitenland",
  [Language.English]: "self-service/application-cak-insurance-family-living-abroad/en"
};
